import React, { useState } from 'react';
import { X } from 'lucide-react';
import { GlassInput } from '../ui/glass-input';
import { CopperButton } from '../ui/copper-button';

export const AddPatientModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    patient_name: '',
    patient_phone: '',
    entry_method: 'Walk-in',
    chief_complaint: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.patient_name.trim() || !formData.patient_phone.trim()) return;
    setSubmitting(true);
    try {
      await onSubmit({
        patient_name: formData.patient_name.trim(),
        patient_phone: `+91 ${formData.patient_phone.trim()}`,
        entry_method: formData.entry_method,
        chief_complaint: formData.chief_complaint.trim() || null,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      style={{ background: 'rgba(28, 25, 23, 0.5)', backdropFilter: 'blur(8px)' }}
      onClick={onClose}
      data-testid="add-patient-modal"
    >
      <div
        className="rounded-[var(--radius-2xl)] p-8 w-full max-w-md animate-slide-up"
        style={{ background: '#FFFFFF', boxShadow: '0 30px 60px rgba(28,25,23,0.20)', border: '1px solid rgba(28,25,23,0.06)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-['Sora'] text-2xl font-bold" style={{ color: '#1C1917' }}>
            Add Patient
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full glass-subtle flex items-center justify-center hover:bg-[rgba(61,90,128,0.08)] transition-all duration-180"
          >
            <X size={16} strokeWidth={1.75} style={{ color: 'var(--color-slate)' }} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <GlassInput
            label="Full Name"
            type="text"
            value={formData.patient_name}
            onChange={(e) => setFormData({ ...formData, patient_name: e.target.value })}
            placeholder="Enter patient name"
            required
            data-testid="add-patient-name-input"
          />

          <div>
            <label className="text-overline block mb-2">PHONE NUMBER</label>
            <div className="glass-subtle rounded-[var(--radius-md)] h-[52px] flex items-center px-4">
              <span className="font-['DM_Mono'] text-sm" style={{ color: '#78716C' }}>+91</span>
              <div className="w-px h-6 mx-3" style={{ backgroundColor: 'rgba(28, 25, 23, 0.12)' }} />
              <input
                type="tel"
                value={formData.patient_phone}
                onChange={(e) => setFormData({ ...formData, patient_phone: e.target.value })}
                className="flex-1 bg-transparent border-none outline-none font-['Inter'] text-base"
                style={{ color: '#1C1917' }}
                placeholder="98765 43210"
                required
                data-testid="add-patient-phone-input"
              />
            </div>
          </div>

          <div>
            <label className="text-overline block mb-2">ENTRY METHOD</label>
            <div className="flex gap-2">
              {['Walk-in', 'Call', 'WhatsApp', 'Appointment'].map(method => (
                <button
                  key={method}
                  type="button"
                  onClick={() => setFormData({ ...formData, entry_method: method })}
                  className={`flex-1 py-2 rounded-[var(--radius-md)] font-['Sora'] text-sm font-medium transition-all duration-180 ${formData.entry_method === method ? 'bg-copper-gradient text-white' : 'glass-subtle hover:bg-[rgba(61,90,128,0.06)]'}`}
                  style={{ color: formData.entry_method === method ? 'white' : '#44403C' }}
                >
                  {method}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-overline block mb-2">CHIEF COMPLAINT (OPTIONAL)</label>
            <textarea
              value={formData.chief_complaint}
              onChange={(e) => setFormData({ ...formData, chief_complaint: e.target.value })}
              className="w-full glass-subtle rounded-[var(--radius-md)] p-4 font-['Inter'] text-sm outline-none resize-none"
              style={{ color: '#1C1917', minHeight: '80px' }}
              placeholder="Describe the reason for visit..."
              data-testid="add-patient-complaint-input"
            />
          </div>

          <button type="submit" className="btn-copper-3d w-full h-[52px] rounded-[var(--radius-lg)] font-['Sora'] text-[15px] font-semibold" disabled={submitting} data-testid="add-patient-submit">
            {submitting ? 'Adding…' : 'Add to Queue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddPatientModal;
